jQuery(document).ready(function ($) {
  if( $('.post-type-archive-product' ) ) {
    $('.post-type-archive-product .product').each(function () {
      const productID = $(this).data('product-id');
      get_products( productID, 'archive' );
    });
  }
  if( $('.single-product') ) {
    const productID = $('#content').data('product-id');
    const showHatchWidget = $('#content').data('show-hatch-widget');

    if( typeof showHatchWidget !== 'undefined' && showHatchWidget !== 1 ) {
      get_products(productID, 'single');
    }
  }
});

function addFilter() {
  const packaging = document.querySelector('#filterPackaging');
  const colors = document.querySelector('#filterColors');

  if( packaging ) {
    var packagingSelectr = new Selectr(packaging, {
      defaultSelected: false,
      searchable: false,
      clearable: true,
      placeholder: akzoNobel.placeholderPackaging,
    });
  }

  if( colors ) {
    var colorSelectr = new Selectr(colors, {
      defaultSelected: false,
      searchable: false,
      clearable: true,
      renderOption: renderColorOptions,
      placeholder: akzoNobel.placeholderColors,
    });
  }

  if( packagingSelectr ) {
    packagingSelectr.on('selectr.change', function () {
      var packagingValue = packagingSelectr.getValue();
      var colorValue = ( colorSelectr ? colorSelectr.getValue() : null );
      showHideHatchOptions(packagingValue, colorValue);
    });
  }

  if( colorSelectr ) {
    colorSelectr.on('selectr.change', function () {
      var packagingValue = ( packagingSelectr ? packagingSelectr.getValue() : null );
      var colorValue = colorSelectr.getValue();
      showHideHatchOptions(packagingValue, colorValue);
    });
  }
}

function renderColorOptions(option) {
  const output = ['<div class="color-option"><span style="background-color:' + option.dataset.hex + ';"></span>', option.text, '</div>'];

  return output.join('');
}

function showHideHatchOptions(packagingValue, colorValue) {
  $('.product__variant').each( function() {
    var hide = false;

    if (packagingValue) {
      if ($(this).data('packaging') !== parseInt( packagingValue ) ) {
        hide = true;
      }
    }
    if (colorValue) {
      if ($(this).data('color') !== colorValue ) {
        hide = true;
      }
    }

    if (hide) {
      $(this).css( 'display', 'none' );
    }
    else {
      $(this).css( 'display', 'block' );
    }
  });
}

function get_products( productID, template ) {
  $.ajax({
    type: 'post',
    dataType: 'json',
    url: akzoNobel.ajax_url,
    data: {
      action: 'show_offers',
      product_id: productID,
      buy_online: akzoNobel.buyOnline,
    },
    success: (function (response) {
      if ('archive' === template) {
        const btn = $('.product[data-product-id="' + productID + '"] .btn__buy-online');
        if( response ) {
          btn.show().css( 'display', 'inline-block' );
        } else {
          btn.remove();
        }
      } else {
        if( 'single' === template ) {

          const tabButton = $('.tab-nav .buy-online');
          const tabContent = $('#tabs .buy-online-tab__inner');
          const hash = window.location.hash;
          if( response ) {
            tabButton.show(function() {
              if( hash ) {
                const offset = tabButton.offset().top;
                $('html,body').animate({scrollTop: offset}, 1000);
              }
            });

            tabContent.replaceWith(response);
            addFilter();
          } else {
            tabButton.remove();
            tabContent.remove();
          }
        }
      }
    }),
    error: function (error) {
      console.log(error);
    }
  });
}
